import { render, staticRenderFns } from "./PlanningPodcastList.vue?vue&type=template&id=5773dc10&scoped=true&"
import script from "./PlanningPodcastList.vue?vue&type=script&lang=js&"
export * from "./PlanningPodcastList.vue?vue&type=script&lang=js&"
import style0 from "./PlanningPodcastList.vue?vue&type=style&index=0&id=5773dc10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5773dc10",
  null
  
)

export default component.exports